import type { TotemEnv } from '../types/totem-env';
const env = window.__TOTENV__ as TotemEnv;

export const isProduction = env.ENV === 'prod';
export const isPreprod = env.ENV === 'preprod';
export const isDemo = env.ENV === 'demo';
export const rawUrl = env.RAW_URL;

export function formGraphQLUrl(isWS: boolean): string {
    if (!env) {
        throw Error('Unhandled __TOTENV__');
    }
    const protocol = isWS
        ? isProduction || isPreprod || isDemo
            ? 'wss://'
            : 'ws://'
        : isProduction || isPreprod || isDemo
          ? 'https://'
          : 'http://';

    // All cases return the same string, so simplify:
    return `${protocol}${rawUrl}/graphql`;
}

export function formApiUrl(): string {
    if (!env) {
        throw Error('Unhandled __TOTENV__');
    }
    const protocol = isProduction || isPreprod || isDemo ? 'https://' : 'http://';
    return `${protocol}${rawUrl}`;
}
